import { useField } from 'formik';
import { type FocusEvent, useCallback } from 'react';

import { Input } from '@air/primitive-input';
import { Label } from '@air/primitive-label';

import { type ExportImagesFormData } from '~/components/ExportImagesModal/ExportImagesModal';
import { EXPORT_IMAGES_SUFFIX_INPUT } from '~/constants/testIDs';

export const PLACEHOLDER_IMAGE_BASE_NAME = 'IMAGE-O1';

type ImageSuffixFormFieldProps = {
  setIsEditing: (isEditing: boolean) => void;
};

export const ImageSuffixFormField = ({ setIsEditing }: ImageSuffixFormFieldProps) => {
  const [{ name, onBlur, onChange, value: suffix }] = useField<ExportImagesFormData['suffix']>('suffix');
  const [{ value: format }] = useField<ExportImagesFormData['ext']>('ext');
  const [{ value: fileName }] = useField<ExportImagesFormData['fileName']>('fileName');

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      onBlur(event);
      setIsEditing(false);
    },
    [onBlur, setIsEditing],
  );
  const handleFocus = useCallback(() => setIsEditing(true), [setIsEditing]);

  return (
    <div className="flex grow flex-col">
      <div className="flex flex-col gap-2">
        <Label className="ads:text-secondary text-gray-11" htmlFor="suffix" size="small">
          Suffix (optional)
        </Label>
        <Input
          className="w-full ads:placeholder:text-placeholder placeholder:text-gray-8"
          data-testid={EXPORT_IMAGES_SUFFIX_INPUT}
          id="suffix"
          name={name}
          onBlur={handleBlur}
          onChange={onChange}
          onFocus={handleFocus}
          placeholder="e.g. _final"
          size="medium"
          type="text"
          value={suffix}
        />
      </div>
      <div className="mt-2 break-all ads:text-metadata text-12 text-gray-10">
        Preview:&nbsp;{fileName}
        {suffix}.{format}
      </div>
    </div>
  );
};
